import jGlobal from '@/global';

let plugin_params = {};
function get_plugin_param(type){
    return $.extend({}, plugin_params[type])
}

function get_plugin_options(type){
    let options = {};
    for (let k in plugin_params[type]) {
        if (/^_/.test(k)) continue;
        options[k] = $.extend({}, plugin_params[type][k])
    }
    return options
}

function set_plugin_param(type, param){
    if (!plugin_params[type]) plugin_params[type] = $.extend({}, param)
}

function get_default_plugin(modtype, params){
    let defaultparams = {
        "left": 0,"top": 0,"parent": '',"width": 100,
        "height": 'auto',"zindex": -1,"childprop": {}
    };
    let modparam = $.extend({}, defaultparams, params),
    curpage = jGlobal.getCurPage(), modinf = curpage.modinfo,
    id = 'layer' + jGlobal.fGuid();
    if (modparam.zindex == -1) {
        let biggestzindex = -1, parent = modparam.parent;
        for (let i = 0, ln = modinf.length; i < ln; i++) {
            if (modinf[i].parent != parent) continue;
            if (biggestzindex < modinf[i].zindex) biggestzindex = modinf[i].zindex
        }
        modparam.zindex = biggestzindex + 1
    }
    modparam.id = id;
    modparam.type = modtype;

    return modparam
}


let propertyarr = {};
function set_plugin_property(key, propertyobj){
    propertyarr[key] = propertyobj
}

function get_plugin_property(key){
    return propertyarr[key]
}


let stylesarr = {};
function set_plugin_styles(key, stylesobj){
    stylesarr[key] = stylesobj
}

function get_plugin_styles(key){
    return stylesarr[key]
}

export default
{
    get_plugin_param,
    set_plugin_param,
    get_plugin_options,
    set_plugin_property,
    get_plugin_property,
    set_plugin_styles,
    get_plugin_styles,
    get_default_plugin
}


// WEBPACK FOOTER //
// ./src/common/mods.js